import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function NuevaEspecialidad() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);

    const [nombre, setNombre] = useState('');

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a administrar personal y proveedores
        const tienePermiso = userdata.up && userdata.up.includes('administrarPersonalProveedores');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        console.log('Client: ' + client.client_id);

        const conf = {
            client_id: client.client_id,
            nombre: nombre
        };

        //console.log(conf);
        axios.post('/especialidad', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'La Especialidad "' + nombre + '" Ha Sido Creada');
                    history.push('/especialidades');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/especialidades">Especialidades</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Especialidad</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nueva Especialidad</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div id="infobasica">
                                            <div className="card-body">

                                                <form id="role-form" onSubmit={handleSubmit}>
                                                    <div className="row mt-4">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="nombre">Nombre</label>
                                                                <input type="text" name="nombre" className="form-control" id="nombre" onChange={(e) => setNombre(e.target.value)} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mr-3 d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                onClick={() => history.push('/especialidades')}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-times mr-2"></i> Cancelar
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                disabled={loading}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-save mr-2"></i> Crear Especialidad
                                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default NuevaEspecialidad;